import Welcome from '../Welcome/Welcome';
import About from '../About/About';
import styles from './Main.module.css';
import Portfolio from '../Portfolio/Portfolio';
import Participants from '../Participants/Participants';
import Contact from '../Contact/Contact';
import PartnerCompanies from '../PartnerCompanies/PartnerCompanies';

export default function Main() {
    return (
        <main className={styles.container} data-testid="welcome">
            <Welcome />
            <section id="about" data-testid="about">
                <About />
            </section>

            <section id="portfolio" data-testid="portfolio">
                <Portfolio />
            </section>

            <section id="participants" data-testid="participants" >
                <Participants />
            </section>

            <section id="contact" data-testid="contact">
                <Contact />
            </section>

            <section id="partnercompanies" data-testid="partnercompanies">
                <PartnerCompanies />
            </section>
        </main>
    );
}